export default "__VITE_ASSET__o0Xyb5GT__"